// extracted by mini-css-extract-plugin
module.exports = {"container":"LongTermView_container__19VDi","content":"LongTermView_content__1Zlz8","mainContent":"LongTermView_mainContent__PZrys","article":"LongTermView_article__2y2Us"};